import { memo } from "react";
import { fmt } from "./utils";

const PerformancePanel = memo(({ liveOhlc, week52 }) => {
  const todayLow = liveOhlc?.low || 0;
  const todayHigh = liveOhlc?.high || 0;
  const open = liveOhlc?.open || 0;
  const prevClose = liveOhlc?.close || 0;
  const w52H = week52?.high;
  const w52L = week52?.low;
  const range = todayHigh - todayLow || 1;
  const w52Range = (w52H && w52L) ? w52H - w52L : 0;
  const currentPos = todayHigh > 0 ? ((liveOhlc?.lastPrice || todayHigh) - todayLow) / range * 100 : 50;
  const w52CurrentPos = w52Range > 0 ? ((liveOhlc?.lastPrice || prevClose) - w52L) / w52Range * 100 : 50;

  return (
    <div className="space-y-5" data-testid="performance-panel">
      <h3 className="text-base font-bold text-gray-900">Performance</h3>
      {/* Today's range */}
      <div>
        <div className="flex justify-between text-sm mb-1.5">
          <div><span className="text-gray-500">Today's Low</span><p className="font-semibold text-gray-900">{fmt(todayLow)}</p></div>
          <div className="text-right"><span className="text-gray-500">Today's High</span><p className="font-semibold text-gray-900">{fmt(todayHigh)}</p></div>
        </div>
        <div className="relative h-1.5 bg-gradient-to-r from-[#eb5b3c] via-yellow-400 to-[#00b386] rounded-full">
          <div className="absolute top-1/2 -translate-y-1/2 w-2.5 h-2.5 bg-gray-900 rounded-full border-2 border-white shadow-sm"
            style={{ left: `${Math.min(Math.max(currentPos, 2), 98)}%` }} />
        </div>
      </div>
      {/* 52W range */}
      {w52H && w52L ? (
        <div>
          <div className="flex justify-between text-sm mb-1.5">
            <div><span className="text-gray-500">52W Low</span><p className="font-semibold text-gray-900">{fmt(w52L)}</p></div>
            <div className="text-right"><span className="text-gray-500">52W High</span><p className="font-semibold text-gray-900">{fmt(w52H)}</p></div>
          </div>
          <div className="relative h-1.5 bg-gradient-to-r from-[#eb5b3c] via-yellow-400 to-[#00b386] rounded-full">
            <div className="absolute top-1/2 -translate-y-1/2 w-2.5 h-2.5 bg-gray-900 rounded-full border-2 border-white shadow-sm"
              style={{ left: `${Math.min(Math.max(w52CurrentPos, 2), 98)}%` }} />
          </div>
        </div>
      ) : (
        <p className="text-xs text-gray-400">52W data temporarily unavailable</p>
      )}
      {/* Key stats — visually partitioned */}
      <div className="grid grid-cols-2 gap-4 pt-2">
        <div className="bg-gray-50 rounded-lg px-4 py-3 flex justify-between items-center">
          <span className="text-sm text-gray-500">Open</span>
          <span className="text-sm font-semibold text-gray-900">{fmt(open)}</span>
        </div>
        <div className="bg-gray-50 rounded-lg px-4 py-3 flex justify-between items-center">
          <span className="text-sm text-gray-500">Prev Close</span>
          <span className="text-sm font-semibold text-gray-900">{fmt(prevClose)}</span>
        </div>
      </div>
    </div>
  );
});

export default PerformancePanel;
